import { masterCriteriaActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  patientMasterCriteriaDetails: null,
  saved_patientMasterCriteria: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case masterCriteriaActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        masterData: null,
      };
    case masterCriteriaActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        masterData: payload,
      };
  case masterCriteriaActionTypes.save_patientMasterCriteria.REQUEST:
    return {
      ...state,
      loading: true,
      saved_patientMasterCriteria: null,
    };
    case masterCriteriaActionTypes.save_patientMasterCriteria.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_patientMasterCriteria: payload,
    };
    case masterCriteriaActionTypes.get_patientMasterCriteria.REQUEST:
    return {
      ...state,
      loading: true,
      patientMasterCriteriaDetails: null,
    };
    case masterCriteriaActionTypes.get_patientMasterCriteria.SUCCESS:
    return {
      ...state,
      loading: false,
      patientMasterCriteriaDetails: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/masteryCriteria/reducers/MasterCriteriaReducer.js